/**
 *
 * WARNING : fichier généré par cli, ne pas le modifier directement
 *
 */
import { gql } from '@apollo/client';

export const GetSimulationProductQuery = gql`
  query GetSimulationProductQuery {
    getSimulationProduct_simulation_product {
      products {
 code  
name  
isSelected  
description  
status  
image  
viewMode  
customOutput1  
customOutput2  
customOutput3  
customOutput4  
customOutput5  
}
      offerCode 
    }
  }
`;

export default GetSimulationProductQuery;
